import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService, SelectItem } from "primeng/api";
import { Table } from "primeng/table";
import { NotificationTypes } from "src/app/app.enums";
import { AppFeaturePermissionDto, SaveSubscriptionRulesRequest, SubscriptionRules, SubscriptionRuleSetUsers } from "src/app/models/subscriptionrules.model";
import { ResponseObject } from "src/app/Services/auth.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { SubscriptionRulesService } from "src/app/Services/subscription-rules.service";
import { UsersService } from "src/app/Services/users.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'subscription-rules',
    templateUrl: './subscription-rules.component.html',
    styleUrls: ['./subscription-rules.component.css'],
    standalone: false
})

export class SubscriptionRulesComponent implements OnInit {
    public subscriptionRules: SubscriptionRules[] = []
    public activeSubscriptionRule!: SaveSubscriptionRulesRequest;
    public currentSubscriptionRule: SubscriptionRules | undefined;
    public subscriptionRulesDataLoaded: boolean = false;
    public subscriptionRuleSetUsersLoaded: boolean = false;
    public subscriptionRule!: SaveSubscriptionRulesRequest;
    public subscriptionRuleDialogVisible: boolean = false;
    public subscriptionRuleUsersDailogVisible: boolean = false;
    public subscriptionRuleSetsDailogVisible: boolean = false;
    public showArtists: boolean = false;
    public subscriptionRuleSetUsers: SubscriptionRuleSetUsers[] = [];
    public filteredRuleSetUsers: SubscriptionRuleSetUsers[] = [];
    public subscriptionRuleSetsDropdown: SelectItem[] = [];
    public subscriptionRuleSetId?: string | undefined;
    activeTabIndex: number = 0;
    public selectedTabIndex: number = 0;
    public selectedActiveTabIndex: number = 0;

    constructor(private subscriptionRulesService: SubscriptionRulesService,
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private confirmationService: ConfirmationService,
        private userService: UsersService,
        private transloco: TranslocoService) {
        this.subscriptionRule = new SaveSubscriptionRulesRequest();
    }

    ngOnInit(): void {
        this.getAllSubscriptionRules();
        this.getActiveSubscriptionRule();
        this.getSubscriptionRuleSetsDropdown();
        this.selectedActiveTabIndex = 0
    }

    public getSubscriptionRuleSetsDropdown() {
        this.ngxSpinnerService.show();
        this.subscriptionRulesService.fetchRuleSetsDropdown().subscribe((ActiveSubscriptionRule: SelectItem[]) => {
            this.subscriptionRuleSetsDropdown = ActiveSubscriptionRule;
            this.ngxSpinnerService.hide()
        }, (error) => { console.error('Error while fetching subscription ruleSets data', error); this.ngxSpinnerService.hide(); })
    }

    public getAllSubscriptionRules() {
        this.ngxSpinnerService.show();
        this.subscriptionRulesService.getSubscriptionRules().subscribe((SubcriptionRules: SubscriptionRules[]) => {
            this.subscriptionRules = SubcriptionRules;
            console.log(this.subscriptionRules)
            this.ngxSpinnerService.hide()
            this.subscriptionRulesDataLoaded = true
        }, (error) => { console.error('Error while fetching subscription rules data', error); this.ngxSpinnerService.hide(); });
    }

    public getActiveSubscriptionRule() {
        this.ngxSpinnerService.show();
        this.subscriptionRulesService.getActiveSubscriptionRules().subscribe((ActiveSubscriptionRule: SaveSubscriptionRulesRequest) => {
            this.activeSubscriptionRule = ActiveSubscriptionRule
            console.log(this.activeSubscriptionRule);
            this.ngxSpinnerService.hide()
            this.subscriptionRulesDataLoaded = true
        }, (error) => { console.error('Error while fetching Active subscription rules data', error); this.ngxSpinnerService.hide(); })
    }

    public onSaveSubscriptionRule() {
        this.ngxSpinnerService.show();
        this.subscriptionRulesService.saveSubscriptionRules(this.subscriptionRule).subscribe((response: ResponseObject) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
                this.notificationsService.showNotification(this.transloco.translate('subscriptionRules.success'), response.ResponseMessage, NotificationTypes.Success);
                this.closeDialog();
                // this.getAllSubscriptionRules();
                this.getActiveSubscriptionRule();
                this.getAllSubscriptionRules();
            }
            else {
                this.notificationsService.showNotification(this.transloco.translate('subscriptionRules.error'), response.ResponseMessage, NotificationTypes.Error);
            }
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
    }


    public closeDialog() {
        this.subscriptionRuleDialogVisible = false
        this.selectedTabIndex = 0
        this.subscriptionRule.appFeaturePermissionDto = []
    }

    public onEditSubscription(subscriptionRuleData: SaveSubscriptionRulesRequest | null) {
        if (subscriptionRuleData) {
            this.subscriptionRule = this.mapSubscriptionRuleData(subscriptionRuleData);
            console.log(this.subscriptionRule)
            this.subscriptionRuleDialogVisible = true;
            setTimeout(() => {
                this.updateRuleName();
            }, 0)
        }
    }

    public toggleFeature(feature: AppFeaturePermissionDto){
        this.subscriptionRule.appFeaturePermissionDto.forEach((permission) => {
            if (permission.FeatureId === feature.FeatureId) {
                permission.IsEnabled = permission.IsEnabled; // Toggle checkbox value
            }
        });
        console.log("this.subscriptionRule.appFeaturePermissionDto",this.subscriptionRule.appFeaturePermissionDto)
    }

    private mapSubscriptionRuleData(subscriptionRuleData: SaveSubscriptionRulesRequest): SaveSubscriptionRulesRequest {
        return {
            RuleName: subscriptionRuleData.RuleName,
            NumberOfGalleryProducts: subscriptionRuleData.NumberOfGalleryProducts,
            NumberOfArtistProducts: subscriptionRuleData.NumberOfArtistProducts,
            NumberOfConnectionsAllowedToGallery: subscriptionRuleData.NumberOfConnectionsAllowedToGallery,
            NumberOfConnectionsAllowedToArtists: subscriptionRuleData.NumberOfConnectionsAllowedToArtists,
            NumberOfConsignmentProductAccepted: subscriptionRuleData.NumberOfConsignmentProductAccepted,
            NumberOfArtTypeSelection: subscriptionRuleData.NumberOfArtTypeSelection,
            NumberOfArtistAIDescriptionCalls: subscriptionRuleData.NumberOfArtistAIDescriptionCalls,
            NumberOfGalleryAIDescriptionCalls: subscriptionRuleData.NumberOfGalleryAIDescriptionCalls,
            NumberOfArtistPortfolios: subscriptionRuleData.NumberOfArtistPortfolios,
            NumberOfGalleryPortfolios: subscriptionRuleData.NumberOfGalleryPortfolios,
            IsActive: subscriptionRuleData.IsActive,
            appFeaturePermissionDto: subscriptionRuleData.appFeaturePermissionDto.map(permission => ({
                Id: permission.Id,
                SubscriptionRuleSetId: permission.SubscriptionRuleSetId,
                FeatureId: permission.FeatureId,
                FeatureKey: permission.FeatureKey,
                FeatureLabel: permission.FeatureLabel,
                FeatureFor: permission.FeatureFor,
                IsEnabled: permission.IsEnabled
            }))
        };
    }

    public onSwitchSubscription(rowData: SubscriptionRules) {
        this.confirmationService.confirm({
            message: this.transloco.translate('subscriptionRules.switchRulesetConfirm', { ruleName: rowData.RuleName }),
            header: this.transloco.translate('subscriptionRules.confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.ngxSpinnerService.show();
                this.subscriptionRulesService.switchSubscriptionRules(rowData.Id).subscribe((responce) => {
                    if (responce.Success) {
                        this.notificationsService.showNotification(this.transloco.translate('subscriptionRules.success'), this.transloco.translate('subscriptionRules.switchedSuccess'), NotificationTypes.Success);
                        this.getAllSubscriptionRules();
                        this.getActiveSubscriptionRule();
                        this.ngxSpinnerService.hide();
                    }
                }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
            }
        });
    }

    public getRulesetUsers(rulesetId: string) {
        this.subscriptionRuleSetId = rulesetId;
        this.currentSubscriptionRule = this.subscriptionRules.find((currentSubscriptionRule) => currentSubscriptionRule.Id == rulesetId)
        this.subscriptionRuleUsersDailogVisible = true;
        this.fetchSubscriptionUsers(rulesetId);
    }

    public onToggleShowArtistsOnly(rulesetId: string) {
        this.showArtists = !this.showArtists;
        this.fetchSubscriptionUsers(rulesetId);
    }

    private fetchSubscriptionUsers(rulesetId: string) {
        this.ngxSpinnerService.show();
        this.subscriptionRulesService.fetchAllSubscriptionRuleSetUsers(rulesetId).subscribe((SubscriptionRuleSetUsersApiResponse: SubscriptionRuleSetUsers[]) => {
            this.subscriptionRuleSetUsers = SubscriptionRuleSetUsersApiResponse;
            this.filterUsers();
            this.ngxSpinnerService.hide();
            this.subscriptionRuleSetUsersLoaded = true;
        }, (error) => {
            console.error('Error while fetching ruleset Users', error);
            this.ngxSpinnerService.hide();
        });
    }

    public onTabChange(event: any) {
        this.activeTabIndex = event.index;
        console.log('Tab changed to:', this.activeTabIndex);
        this.filterUsers();
    }

    public filterUsers() {
        if (!this.subscriptionRuleSetUsers) return;
        // Use activeTabIndex to determine the view (0 = Gallery, 1 = Artist)
        this.filteredRuleSetUsers = this.subscriptionRuleSetUsers.filter(user => {
            return this.activeTabIndex === 1 ? user.IsArtist : !user.IsArtist;
        });
        console.log(this.filteredRuleSetUsers);
    }


    public onCloseAllRuleSetUsersDialog() {
        this.subscriptionRuleUsersDailogVisible = false;
        // Reset form-related data, variables, and any other dynamic states
        this.filteredRuleSetUsers = [];
        this.subscriptionRuleSetUsersLoaded = false;
        this.activeTabIndex = 0; // Reset active tab to the default if required
        this.showArtists = false; // Reset any flags controlling visibility of artists or galleries
    }

    public onCloseSubscriptionRuleSetsDialog() {
        this.subscriptionRuleSetsDailogVisible = false;
    }

    public selectedUser?: SubscriptionRuleSetUsers;

    public onEditUserSubscription(rowData: SubscriptionRuleSetUsers) {
        this.selectedUser = rowData;
        this.subscriptionRuleSetsDailogVisible = true;
    }

    public assignSubscriptionRuleSet() {
        if (!this.subscriptionRuleSetId) return;

        this.confirmationService.confirm({
            message: this.transloco.translate('subscriptionRules.changeRulesetConfirm', { name: this.selectedUser?.Name }),
            header: this.transloco.translate('subscriptionRules.confirmation'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.ngxSpinnerService.show()
                this.userService.updateSubscriptionRuleSetUser(this.selectedUser?.Id!, this.subscriptionRuleSetId!).subscribe((responce: ResponseObject) => {
                    if (responce.Success) {
                        console.log(responce.ResponseData)
                        this.notificationsService.showNotification(this.transloco.translate('subscriptionRules.success'), this.transloco.translate('subscriptionRules.changesSaved'), NotificationTypes.Success);
                        this.onCloseSubscriptionRuleSetsDialog();
                        this.fetchSubscriptionUsers(this.subscriptionRuleSetId!);
                    }
                }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
            }
        });
    }

    public preventNegativeValues(event: any, property: 'NumberOfArtistProducts' | 'NumberOfConnectionsAllowedToArtists' | 'NumberOfArtTypeSelection' | 'NumberOfArtistAIDescriptionCalls' | 'NumberOfConsignmentProductAccepted' | 'NumberOfConnectionsAllowedToGallery' | 'NumberOfGalleryProducts' | 'NumberOfGalleryAIDescriptionCalls' | 'NumberOfArtistPortfolios' | 'NumberOfGalleryPortfolios'): void {
        let value = event.target.value;
        value = value.replace(/-/g, '');
        // Allow only valid decimal numbers (positive values with an optional decimal point)
        const regex = /^[0-9]*\.?[0-9]*$/;
    
        if (!regex.test(value)) {
            // If invalid, revert to previous valid value or set to empty string
            this.subscriptionRule[property] = 0;
        } else {
            // Ensure value remains a valid positive decimal number
            this.subscriptionRule[property] = value;
        }
        if (event.target.value < 0) {
            this.subscriptionRule[property] = 0;
        }
    }

    removeDateTimeFromRuleName(ruleName: string): string {
        console.log(ruleName)
        return ruleName.replace(/ - \d{1,2}-[A-Za-z]{3}-\d{4} \d{1,2}:\d{2} - \d{1,2}-[A-Za-z]{3}-\d{4} \d{1,2}:\d{2}$/, '');
    }
      
    // Call this function where needed
    public updateRuleName(): void {
        if (this.subscriptionRule && this.subscriptionRule.RuleName && this.subscriptionRuleDialogVisible == true) {
            this.subscriptionRule.RuleName = this.removeDateTimeFromRuleName(this.subscriptionRule.RuleName);
            console.log(this.subscriptionRule.RuleName)
        }
    }

}
